export const sanitizeInput = (text) => {
  return text.trim();
};

export const sanitizeInputObject = (inputObj) => {
  const keys = Object.keys(inputObj);

  const sanitizeIn = {};

  keys.forEach((key) => {
    sanitizeIn[key] =
      typeof inputObj[key] === "string"
        ? sanitizeInput(inputObj[key])
        : inputObj[key];
  });

  return sanitizeIn;
};
